import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

/**
 * Lazily-loaded entry point for the Meetings pill content.
 *
 * `MeetingsPanelWithProvider` statically pulls in a fairly heavy subtree
 * (smart-card `Card`, `react-relay`, the embedded recording modal and the
 * smart-card provider). Importing it eagerly from `Feed.tsx` added that weight
 * to the feed's critical bundle even when the feature gate is off, which
 * regressed page-load performance (COPPER-958).
 *
 * The Meetings panel only renders when the (gated) Meetings pill is the selected
 * panel, so we load it after paint / on demand instead. This keeps the heavy
 * dependencies out of the initial bundle and off the critical path.
 */
export const LoadableMeetingsPanel: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-MeetingsPanel" */ './MeetingsPanelWithProvider.tsx'
			)
		).MeetingsPanelWithProvider,
});
